import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.promise.finally.js";
import React from 'react';
import { baseLogin } from '@isyc-react/oc-api/auth';
import { useUserReadCurrentLazyQuery as useUserReadCurrentLazyQueryReal } from '@isyc-react/oc-api';
const autoLogin = () => {
  const user = process.env.autologin_user || 'isyc';
  const pass = process.env.autologin_pass || 'isyc159';
  const bu = process.env.autologin_bu || 'SHARE';
  return baseLogin({
    username: user,
    password: pass,
    bu
  });
};
export const useUserReadCurrentLazyQuery = options => {
  const [getCurrentUserReal, state] = useUserReadCurrentLazyQueryReal(options);
  const getCurrentUser = React.useCallback(() => {
    if (process.env.NODE_ENV === 'development' && process.env.autologin === 'true') {
      autoLogin().catch(e => console.error('[Dev AutoLogin] Failed to autologin on development', e.response)).finally(getCurrentUserReal);
    } else getCurrentUserReal();
  }, [getCurrentUserReal]);
  return [getCurrentUser, state];
};